import BaseMarker from "./base_marker"

export default class StandardMarker extends BaseMarker {
  static anchor() {
    return "bottom";
  }

  static iconStyle() {
    return {
      "width": "14px",
      "position": "absolute",
      "left": "8px",
      "top": "9px",
    };
  }

  static iconSvgAttributes() {
    return { "fill": "white" };
  }

  static markerStyle() {
    return { "width": `${this.dimensions().width}px` };
  }

  static markerSvgAttributes() {
    return {
      "fill": "#8a6bee",
      "stroke": "#b8a6f4",
      "stroke-width": 5,
      "stroke-opacity": 1
    };
  }

  static markerType() {
    return "standard";
  }
}
